/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Export_ActionInputs */

const en_us2_profile_editors_export_action = /** @type {(inputs: Profile_Editors_Export_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

const pt_br2_profile_editors_export_action = /** @type {(inputs: Profile_Editors_Export_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar`)
};

const es_419_profile_editors_export_action = /** @type {(inputs: Profile_Editors_Export_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar`)
};

const pt_pt2_profile_editors_export_action = /** @type {(inputs: Profile_Editors_Export_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar`)
};

const fr_fr2_profile_editors_export_action = /** @type {(inputs: Profile_Editors_Export_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter`)
};

const de_de2_profile_editors_export_action = /** @type {(inputs: Profile_Editors_Export_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportieren`)
};

const it_it2_profile_editors_export_action = /** @type {(inputs: Profile_Editors_Export_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta`)
};

/**
* | output |
* | --- |
* | "Export" |
*
* @param {Profile_Editors_Export_ActionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_export_action = /** @type {((inputs?: Profile_Editors_Export_ActionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Export_ActionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_export_action(inputs)
	if (locale === "es-419") return es_419_profile_editors_export_action(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_export_action(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_export_action(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_export_action(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_export_action(inputs)
	return en_us2_profile_editors_export_action(inputs)
});
export { profile_editors_export_action as "profile-editors.export_action" }